import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  formContainer: {
    marginTop: theme.spacing(3),
  },
  form: {
    marginTop: theme.spacing(3),
  },
}))

export default useStyles

